export default {
  replacementProcessedRadioLabel: {
    id: 'asp_action_bar_ship_back_item_step_replacement_processed_radio_label',
    defaultMessage:
      'I confirm that this replacement has been processed and should be removed from my list of open requests.',
  },
  trackingNumber: {
    id: 'asp_action_bar_ship_back_item_step_tracking_number',
    defaultMessage: 'Tracking number',
  },
  carrier: {
    id: 'asp_action_bar_ship_back_item_step_provider',
    defaultMessage: 'Provider',
  },
  requiredMessageError: {
    id: 'asp_action_bar_ship_back_item_step_required_error_message',
    defaultMessage: 'This field is required',
  },
  submit: {
    id: 'asp_action_bar_ship_back_item_step_submit',
    defaultMessage: 'Send',
  },
  addresses: {
    id: 'sav_platform_return_addresses',
    defaultMessage: 'Return address',
  },
}
